import { useState, useEffect } from "react"
import api from "../components/api"

const MeuPerfil = () => {


    const us_codigo = sessionStorage.getItem('us_codigo')


    const [senha, setSenha] = useState('')
    const [confirmaSenha, setConfirmaSenha] = useState('')

    const [email, setEmail] = useState('')
    const [senhaEmail, setSenhaEmail] = useState('')



    const carregaEmail = () => {

        api.get(`usuario/${us_codigo}`).then((result) => {

            var data = result.data[0]          
            
            setEmail(data.email ? data.email : '')
            

        }).catch((err) => {

            console.log(err.response)

        })



    }


    const salvarEmail = () => {


        if (email == '' || email == null) {

            window.toastr.error('<b>E-mail</b> não pode ficar em branco!')
            return false

        }

        if (senhaEmail == '' || senhaEmail == null) {

            window.toastr.error('<b>Senha do e-mail</b> não pode ficar em branco!')
            return false

        }


        var dataPost = {

            email: email,
            senha: senhaEmail,

        }


        window.$.confirm({
            //icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
            title: 'Confirmação',
            content: 'Confirma salvar as informações de e-mail?',
            buttons: {
                Sim: function () {


                    

                    api.put(`emailAdm/${us_codigo}`, dataPost).then((result) => {

                        //console.log(result.data)
                        window.toastr.success('Registro salvo com sucesso!')
                        setSenhaEmail('')

                    }).catch((err) => {

                        console.log(err.response)

                    })



                   

                },
                Cancelar: function () {
                    //$.alert('Canceled!');
                }

            },

        });
        
    }



    const salvar = () => {


        if (senha != confirmaSenha) {

            window.toastr.error('Senhas não conferem!')
            return false

        } else {


            if (senha.length <= 4) {

                window.toastr.error('A senha precisa ter no mínimo 5 caracteres!')
                return false
            }

            const regex = /[0-9]/;
            
            if (!regex.test(senha)) {

                window.toastr.error('A senha precisa ter ao menos um caractere numérico!')
                return false

            } else {

                const regex = /[A-Z]/;
                if (!regex.test(senha)) {

                    window.toastr.error('A senha precisa ter ao menos uma letra maiúscula!')
                    return false

                } else {

                    //let regex = /^(?=.*[@!#$%^&*()/\\])[@!#$%^&*()/\\a-zA-Z0-9]{8,20}$/;
                    //let regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[$*&@#])[0-9a-zA-Z$*&@#]{5,}$/
                    let regex = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{4,}$/)

                    if (!regex.test(senha)) {

                        window.toastr.error('Sua senha precisa ter ao menos um caractere especial!')
                        return false

                    }

                }
                
            }

        }

        var dataPost = {

            senha: senha,

        }


        window.$.confirm({
            //icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
            title: 'Confirmação',
            content: 'Confirma alterar a senha?',
            buttons: {
                Sim: function () {


                    api.put(`senhaAdm/${us_codigo}`, dataPost).then((result) => {

                        //console.log(result.data)
                        //window.$("#modalAlteraSenhaAdm").modal('hide');
                        window.toastr.success('Salvo com sucesso!')
                        setSenha('')
                        setConfirmaSenha('')

                                                
            
                    }).catch((err) => {
            
                        console.log(err.response)
            
                    })


                   

                },
                Cancelar: function () {
                    //$.alert('Canceled!');
                }

            },

        });




    }


    useEffect(() => {

        carregaEmail()

    }, [])


    return (


        <div>

                <div className="modal fade" id="modalMeuPerfil" tabindex="-1" role="dialog">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">Configurações</h1>
                            </div>
                            <div class="modal-body">
                                    
                                    <div class="panel-body">

                                    <ul className="nav nav-tabs">
                                        <li className="active"><a href="#tabMeuPerfil1" data-toggle="tab">Senha de acesso</a></li>
                                        <li ><a href="#tabMeuPerfil2" data-toggle="tab" onClick={() => {} } >E-mail</a></li>
                                        
                                        
                                        
                                    </ul>

                                    <div class="tab-content">
                                        <div class="tab-pane fade in active" id="tabMeuPerfil1">
                                            <div class="panel-body">

                                                <div className="row">

                                                    <div class="col-md-12">
                                                        <div class="form-group">
                                                            <label>Senha</label>
                                                            <input type="password" class="form-control" placeholder="" value={senha} onChange={event => setSenha(event.target.value)} />
                                                                            
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <div class="form-group">
                                                            <label>Confirma senha</label>
                                                            <input type="password" class="form-control" placeholder="" value={confirmaSenha} onChange={event => setConfirmaSenha(event.target.value)} />
                                                                            
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12" style={{ textAlign: 'right'}}>
                                                    
                                                        <button type="button" className="btn btn-success" onClick={() => salvar()}>Salvar</button>

                                                    </div>


                                                </div>

                                            </div>
                                        </div>
                                        <div class="tab-pane fade in " id="tabMeuPerfil2">
                                            <div class="panel-body">

                                                <div className="row">

                                                    <div class="col-md-12">
                                                        <div class="form-group">
                                                            <label>E-mail</label>
                                                            <input type="text" class="form-control" placeholder="" value={email} onChange={event => setEmail(event.target.value)} />
                                                                            
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <div class="form-group">
                                                            <label>Senha E-mail</label>
                                                            <input type="password" class="form-control" placeholder="" value={senhaEmail} onChange={event => setSenhaEmail(event.target.value)} />
                                                                            
                                                        </div>
                                                    </div>

                                                    <div class="col-md-12" style={{ textAlign: 'right'}}>
                                                    
                                                        <button type="button" className="btn btn-success" onClick={() => salvarEmail()}>Salvar</button>

                                                    </div>


                                                </div>

                                            </div>
                                        </div>

                                    </div>

                                        
                                       



                                    </div>


                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                
                            </div>
                        </div>
                    </div>
                </div>

        </div>


    )

}


export default MeuPerfil